webpackJsonp([133195837220771],{

/***/ 134:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _PostList = __webpack_require__(119);
	
	var _PostList2 = _interopRequireDefault(_PostList);
	
	var _H = __webpack_require__(30);
	
	var _H2 = _interopRequireDefault(_H);
	
	var _reactHelmet = __webpack_require__(15);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _reactIntl = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Blog = function Blog(props) {
	  return _react2.default.createElement(
	    'section',
	    { className: 'posts' },
	    _react2.default.createElement(
	      _reactIntl.FormattedMessage,
	      { id: 'posts' },
	      function (txt) {
	        return _react2.default.createElement(
	          'header',
	          null,
	          _react2.default.createElement(_reactHelmet2.default, {
	            title: txt,
	            meta: [{ name: 'description', content: txt }]
	          }),
	          _react2.default.createElement(
	            _H2.default,
	            null,
	            txt
	          )
	        );
	      }
	    ),
	    _react2.default.createElement(_PostList2.default, {
	      posts: props.data.allMarkdownRemark.edges.map(function (p) {
	        return p.node;
	      })
	    })
	  );
	};
	
	Blog.propTypes = {
	  data: _propTypes2.default.object.isRequired
	};
	
	exports.default = Blog;
	module.exports = exports['default'];

/***/ }),

/***/ 470:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _blog = __webpack_require__(134);
	
	var _blog2 = _interopRequireDefault(_blog);
	
	var _graphql = __webpack_require__(13);
	
	var _graphql2 = _interopRequireDefault(_graphql);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(_blog2.default, props);
	};
	
	var pageQuery = exports.pageQuery = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-blog-pt-js-4456df779ca4af9ebf04.js